type IframeMessageType = "createDeal" | "updateDeal" | "createLoan" | "updateLoan" | "end";

interface IframeMessage<T = any> {
  type: IframeMessageType;
  payload?: T;
}

class IframeService {
  private targetOrigin: string;

  constructor(targetOrigin: string = "*") {
    this.targetOrigin = targetOrigin;
  }

  sendMessage<T = any>(type: IframeMessageType, payload?: T) {
    if (window.parent && window.parent !== window) {
      const message: IframeMessage<T> = { type, payload };
      window.parent.postMessage(message, this.targetOrigin);
    }
  }
}

export const iframeService = new IframeService();

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // If an error occurs, assume we are in an iframe
  }
};
